module.exports = __webpack_public_path__ + "static/media/big-o-tech.8130a59a.svg";